import type { MouseEvent } from "react";
import { useState } from "react";

import type { ChangeJobVisibilityFormData } from "@js/apps/employer/forms/change-job-visibility";
import type { Job } from "@js/types/jobs";
import { isEllipsisVisible } from "@js/utils";

import { usePatchJobMutation } from "../../api";
import { useGetDefaultActionsContextValue } from "../../hooks/get-default-job-actions";

type UseJobManagementHeaderProps = {
  job: Job;
};

export const useJobManagementHeader = ({
  job,
}: UseJobManagementHeaderProps) => {
  const jobActionsContextValue = useGetDefaultActionsContextValue();
  const [patchJob] = usePatchJobMutation();

  const onChangeVisibility = ({ is_private }: ChangeJobVisibilityFormData) => {
    void patchJob({ jobId: job.id, data: { is_private } });
  };

  const [showJobTitleTooltip, setShowJobTitleTooltip] = useState(false);
  const updateTooltipVisibility = (event: MouseEvent<HTMLSpanElement>) => {
    if (!event.target || !(event.target instanceof Element)) return;
    setShowJobTitleTooltip(isEllipsisVisible(event.target));
  };

  return {
    jobActionsContextValue,
    showJobTitleTooltip,
    updateTooltipVisibility,
    onChangeVisibility,
  };
};
